// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk for fetching job resume stats
// export const fetchJobResumeStats = createAsyncThunk(
//   "jobResumeStats/fetchJobResumeStats",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         "http://localhost:3000/super-admin/job-resume-stats"
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch data");
//       }

//       const result = await response.json();

//       if (result.success) {
//         return result.data;
//       } else {
//         throw new Error(result.message || "Failed to fetch stats");
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const jobResumeStatsSlice = createSlice({
//   name: "jobResumeStats",
//   initialState: {
//     data: {
//       TotalJobPostings: 0,
//       TotalResumesScreened: 0,
//       TotalinterviewConductedCount: 0,
//     },
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//     resetStats: (state) => {
//       state.data = {
//         TotalJobPostings: 0,
//         TotalResumesScreened: 0,
//         TotalinterviewConductedCount: 0,
//       };
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchJobResumeStats.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchJobResumeStats.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchJobResumeStats.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearError, resetStats } = jobResumeStatsSlice.actions;
// export default jobResumeStatsSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

// Async thunk for fetching job resume stats
export const fetchJobResumeStats = createAsyncThunk(
  "jobResumeStats/fetchJobResumeStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/super-admin/job-resume-stats`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.message || "Failed to fetch stats");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const jobResumeStatsSlice = createSlice({
  name: "jobResumeStats",
  initialState: {
    data: {
      TotalJobPostings: 0,
      TotalResumesScreened: 0,
      TotalinterviewConductedCount: 0,
    },
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetStats: (state) => {
      state.data = {
        TotalJobPostings: 0,
        TotalResumesScreened: 0,
        TotalinterviewConductedCount: 0,
      };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobResumeStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobResumeStats.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobResumeStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, resetStats } = jobResumeStatsSlice.actions;
export default jobResumeStatsSlice.reducer;
